<template>
  <div class="home">
    <div class="section-1">
      <v-container class="py-8 px-6 px-md-0 py-md-15">
        <v-row>
          <!-- Secure Online Short-Term Loans -->
          <v-col cols="12" class="ma-0">
            <h3 class="heading-h3 mb-md-9">Secure Online Short-Term Loans</h3>
          </v-col>

          <v-row class="justify-center">
            <v-col v-for="(card, i) in cards" :key="i" cols="12" sm="6" md="4">
              <v-hover v-slot:default="{ props }">
                <v-card
                  class="loan-card"
                  elevation="isHovering ? 6 : 2"
                  v-bind="props"
                >
                  <div class="icon-wrapper">
                    <v-icon size="48" color="white">{{ card.icon }}</v-icon>
                  </div>

                  <h4 class="loan-card-title">{{ card.title }}</h4>
                  <p v-if="!showFullTexts[i]" class="loan-card-text">
                    {{ card.text.substring(0, 200) }}...
                  </p>
                  <p v-else class="loan-card-text">{{ card.text }}</p>
                  <span
                    @click="toggleText(i)"
                    class="see-more"
                    style="
                      cursor: pointer;
                      text-decoration: underline;
                      color: grey;
                    "
                  >
                    {{ showFullTexts[i] ? "" : "Read more" }}
                  </span>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>

          <!-- Apply Here -->
          <v-col class="d-flex justify-center mt-10 mb-5" cols="12">
            <v-btn
              :to="{ name: 'RegistrationPage' }"
              class="b-button text-capitalize hidden-xs-only"
              width="290"
              height="48"
              style="background-color: #08338f; color: white"
            >
              APPLY HERE
            </v-btn>

            <v-btn
              :to="{ name: 'RegistrationPage' }"
              class="b-button text-capitalize hidden-sm-and-up my-n6"
              width="100%"
              height="48"
              style="background-color: #08338f; color: white"
            >
              APPLY HERE
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "LimeLoansSection1",

  data() {
    return {
      showFullTexts: [false, false, false],
      cards: [
        {
          icon: "mdi-clock-time-three",
          title: "Quick and Secure Online Loan Applications",
          text: `Experience fast, hassle-free personal loans through our streamlined online application process.
          With prompt approvals and rapid funding, we make borrowing convenient and efficient. Our secure platform
          offers competitive rates, flexible terms, and requires minimal documentation - designed to support your short-term
          financial needs with confidence and ease. Rely on Century Financial Service for trusted, reliable lending solutions.`,
        },
        {
          icon: "mdi-cash",
          title: "Clarity You Can Count On",
          text: `At Century FS, we believe in complete transparency. Our personal loan terms come with no hidden fees —
          every rate, fee, and condition is clearly outlined from the start. We make sure you have all the information you
          need to borrow with confidence. With a straightforward, honest approach, our platform empowers you to make
          informed financial decisions. Trust Century FS for a seamless lending experience built on clarity, integrity,
          and reliability.`,
        },
        {
          icon: "mdi-lock",
          title: "Secure Online Lending You Can Trust",
          text: `At Century FS, protecting your personal and financial information is our top priority. We adhere to the highest
          global security standards, including those set by Visa and Mastercard, ensuring a safe and secure platform for
          all your online loan transactions.
          
          Our full compliance with the National Credit Regulator and strict adherence to South African laws reflect our
          unwavering commitment to data integrity and privacy. With advanced encryption, robust cybersecurity protocols,
          and rigorous legal safeguards, your information is protected against unauthorized access and digital threats.
          
          Experience true peace of mind — at Century FS, your data isn't just protected, it's fortified.`,
        },
      ],
      fastLoanText:
        "Experience fast, hassle-free personal loans through our streamlined online application process. With prompt approvals and rapid funding, we make borrowing convenient and efficient. Our secure platform offers competitive rates, flexible terms, and requires minimal documentation - designed to support your short-term financial needs with confidence and ease. Rely on Century Financial Service for trusted, reliable lending solutions.",
      transparentLoanText:
        "At Century FS, we believe in complete transparency. Our personal loan terms come with no hidden fees - every rate, fee, and condition is clearly outlined from the start. We make sure you have all the information you need to borrow with confidence. With a straightforward, honest approach, our platform empowers you to make informed financial decisions. Trust Century FS for a seamless lending experience built on clarity, integrity, and reliability",
      secureLoanText:
        "At Century FS, protecting your personal and financial information is our top priority. We adhere to the highest global security standards, including those set by Visa and Mastercard, ensuring a safe and secure platform for all your online loan transactions. Our full compliance with the National Credit Regulator and strict adherence to South African laws reflect our unwavering commitment to data integrity and privacy. With advanced encryption, robust cybersecurity protocols, and rigorous legal safeguards, your information is protected against unauthorized access and digital threats. Experience true peace of mind - at Century FS, your data isn't just protected, it's fortified.",
    };
  },

  methods: {
    toggleText(index) {
      this.$set(this.showFullTexts, index, !this.showFullTexts[index]);
    },
  },
};
</script>

<style scoped lang="scss">
.section-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #08338f;
  margin-bottom: 0.5rem;
}

.section-subtitle {
  font-size: 1.25rem;
  color: #666;
  margin-bottom: 2rem;
}

.loan-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  transition: all 0.3s ease;
  height: 100%;

  &:hover {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  }
}

.icon-wrapper {
  background: linear-gradient(135deg, #08338f, #1e3a8a);
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}

.loan-card-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #08338f;
}

.loan-card-text {
  font-size: 1rem;
  color: #444;
  line-height: 1.6;
}

.apply-button {
  background-color: #08338f;
  color: white;
  padding: 14px 32px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  text-transform: capitalize;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #052e75;
  }
}
</style>
